export const RESPONSE_STREAM_FORMAT = {
  NONE: "none",
  AI_SDK_DATA_STREAM: "ai_sdk_data_stream",
} as const

export type ResponseStreamFormatValue =
  (typeof RESPONSE_STREAM_FORMAT)[keyof typeof RESPONSE_STREAM_FORMAT]

const RESPONSE_STREAM_FORMAT_SET = new Set<string>(
  Object.values(RESPONSE_STREAM_FORMAT),
)

export const isResponseStreamFormatValue = (
  value: string,
): value is ResponseStreamFormatValue => RESPONSE_STREAM_FORMAT_SET.has(value)
